var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#003AFF",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-96",
    fill: "#00FFC2",
    points: "9.65752 30.92291 16.00002 24.58041 22.34252 30.92291 22.34252 35.91361 16.00002 29.57111 9.65752 35.91361"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-98",
    fill: "#00FFC2",
    points: "9.65752 22.6759 16.00002 16.3334 22.34252 22.6759 22.34252 27.6666 16.00002 21.3241 9.65752 27.6666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#00FFC2",
    points: "9.65752 14.42888 16.00002 8.08638 22.34252 14.42888 22.34252 19.41958 16.00002 13.07708 9.65752 19.41958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.52deddef391211ad2c285f2fd5182361.svg";
export { ForwardRef as ReactComponent };